
import React from "react";
import { Settings } from "lucide-react";
import { SettingsTabs } from "./settings/SettingsTabs";

export function UserSettings() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Settings className="h-5 w-5" />
          Account Settings
        </h2>
        <p className="text-sm text-muted-foreground">Manage your account preferences</p>
      </div>
      
      <SettingsTabs />
    </div>
  );
}
